import {
    CoreApiFilterObject,
    FILTER_TYPES,
} from '@/coreApi/filters/coreApiFilterObject'

const FILTER_ID_PAGE_FILTER = 'pf'

const coreApiPageFilters = [
    {
        title: 'Referrers',
        key: 'r',
        field_name: 'referer_domain',
        filter_type: 'multiple-select',
        data: [
            {
                label: 'Direct',
                value: 'site_direct',
            },
            {
                label: 'Home',
                value: 'site_internal_home',
            },
            {
                label: 'Internal',
                value: 'site_internal',
            },
            {
                label: 'Infinite Scroll',
                value: 'site_internal_infinite_scroll',
            },
            {
                label: 'Google Organic',
                value: 'search_google_organic',
            },
            {
                label: 'Google Amp',
                value: 'search_google_amp',
            },
            {
                label: 'Google News',
                value: 'search_google_new',
            },
            {
                label: 'Google CPC',
                value: 'search_google_cpc',
            },
            {
                label: 'Google Discover',
                value: 'search_google_discover',
            },
            {
                label: 'Facebook',
                value: 'social_facebook',
            },
            {
                label: 'Facebook Instance Article',
                value: 'social_facebook_instant_article',
            },
            {
                label: 'Instagram',
                value: 'social_instagram_referrer',
            },
            {
                label: 'Twitter',
                value: 'social_twitter_referrer',
            },
            {
                label: 'Yandex',
                value: 'yandex',
            },
            {
                label: 'Yahoo',
                value: 'yahoo',
            },
            {
                label: 'eksisozluk.com',
                value: 'eksisozluk.com',
            },
            {
                label: 'Bundle',
                value: 'bundle',
            },
        ],
    },
    {
        title: 'Source Referrers',
        key: 'ord',
        field_name: 'origin_referer_domain',
        filter_type: 'multiple-select',
        data: [
            {
                label: 'Direct',
                value: 'site_direct',
            },
            {
                label: 'Google Organic',
                value: 'search_google_organic',
            },
            {
                label: 'Google Amp',
                value: 'search_google_amp',
            },
            {
                label: 'Google News',
                value: 'search_google_new',
            },
            {
                label: 'Google CPC',
                value: 'search_google_cpc',
            },
            {
                label: 'Google Discover',
                value: 'search_google_discover',
            },
            {
                label: 'Facebook',
                value: 'social_facebook',
            },
            {
                label: 'Facebook Instance Article',
                value: 'social_facebook_instant_article',
            },
            {
                label: 'Instagram',
                value: 'social_instagram_referrer',
            },
            {
                label: 'Twitter',
                value: 'social_twitter_referrer',
            },
            {
                label: 'Yandex',
                value: 'yandex',
            },
            {
                label: 'Yahoo',
                value: 'yahoo',
            },
            {
                label: 'Bundle',
                value: 'bundle',
            },
        ],
    },
    {
        title: 'UTM Referrers',
        key: 'ur',
        field_name: 'referer_utm',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'bundle',
            'email',
            'facebook',
            'google',
            'webpush',
            't.co',
        ],
    },
    {
        title: 'UTM Source Referrers',
        key: 'usr',
        field_name: 'origin_referer_utm',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'bundle',
            'email',
            'facebook',
            'google',
            'webpush',
            't.co',
        ],
    },
    {
        title: 'Devices',
        key: 'd',
        field_name: 'device',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Desktop',
                value: 'desktop',
            },
            {
                label: 'Mobile',
                value: 'mobile',
            },
            {
                label: 'Tablet',
                value: 'tablet',
            },
        ],
    },
    {
        title: 'Sources',
        key: 's',
        field_name: 'source',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Web',
                value: 'web',
            },
            {
                label: 'Amp',
                value: 'amp',
            },
            {
                label: 'Instance Article',
                value: 'ia',
            },
            {
                label: 'Android App',
                value: 'androidApp',
            },
            {
                label: 'IOS App',
                value: 'iosApp',
            },
        ],
    },
    {
        title: 'Domains',
        key: 'ds',
        field_name: 'page_domains',
        filter_type: 'checkbox',
        data: [
            {
                label: 'haberler.com',
                value: 'haberler.com',
            },
        ],
    },
    {
        title: 'Categories',
        key: 'c',
        field_name: 'breadcrumb_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'Haber', value: 'haber' },
            { label: 'Son Dakika', value: 'son dakika' },
            { label: 'Güncel', value: 'güncel' },
            { label: 'Ekonomi', value: 'ekonomi' },
            { label: 'Magazin', value: 'magazin' },
            { label: 'Spor', value: 'spor' },
            { label: 'Dünya', value: 'dünya' },
            { label: 'Kuponlar', value: 'kuponlar' },
            { label: 'Tümü', value: 'tümü' },
        ],
    },
    {
        title: 'Authors',
        key: 'a',
        field_name: 'author_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'Abdullah Teymur', value: 'abdullah teymur' },
            { label: 'Abdurrahim Efe', value: 'abdurrahim efe' },
            { label: 'Ali Gülhan', value: 'ali gülhan' },
            { label: 'Aslan Aslan', value: 'aslan aslan' },
            { label: 'Ayça Elal', value: 'ayça elal' },
            { label: 'Barış Polat', value: 'barış polat' },
            { label: 'Betül Cirit', value: 'betül cirit' },
            { label: 'Bilal Ceran', value: 'bilal ceran' },
            { label: 'Ecem Altan', value: 'ecem altan' },
            { label: 'Emir Ceran', value: 'emir ceran' },
            { label: 'Emre İliksiz', value: 'emre iliksiz' },
            { label: 'Erdem Aksoy', value: 'erdem aksoy' },
            { label: 'Eymen Dursun', value: 'eymen dursun' },
            { label: 'Gözde Nur Bayar', value: 'gözde nur bayar' },
            { label: 'İbrahim Çelik', value: 'ibrahim çelik' },
            { label: 'İsmail Elal', value: 'ismail elal' },
            { label: 'Kaan Güler', value: 'kaan güler' },
            { label: 'Kübra Çolakbüyük', value: 'kübra çolakbüyük' },
            { label: 'Mesut Şahin', value: 'mesut şahin' },
            { label: 'Neslinur Mutlu', value: 'neslinur mutlu' },
            { label: 'Olgun Kızıltepe', value: 'olgun kızıltepe' },
            { label: 'Onur BAYRAM', value: 'onur bayram' },
            { label: 'Osman DEMİR', value: 'osman demir' },
            { label: 'Şahin Solak', value: 'şahin solak' },
            { label: 'Salih Söğüt', value: 'salih söğüt' },
            { label: 'Selahattin Demirel', value: 'selahattin demirel' },
            { label: 'Sena Demiröz', value: 'sena demiröz' },
            { label: 'Senem Zafer', value: 'senem zafer' },
            { label: 'Serhıldan Hülakü', value: 'serhıldan hülakü' },
            { label: 'Sumru Tarhan', value: 'sumru tarhan' },
            { label: 'Şimal Güdüm', value: 'şimal güdüm' },
            { label: 'Tahsin Erkin Erk', value: 'tahsin erkin erk' },
            { label: 'Temsilci', value: 'temsilci' },
            { label: 'Turan Yiğittekin', value: 'turan yiğittekin' },
            { label: 'Yakupcan Aydemir', value: 'yakupcan aydemir' },
            { label: 'Zehra Aygör', value: 'zehra aygör' },
            { label: 'Zehra Yaşık', value: 'zehra yaşık' },
        ],
    },
    {
        title: 'Editors',
        key: 'ed',
        field_name: 'author_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'Abdullah Teymur', value: 'abdullah teymur' },
            { label: 'Abdurrahim Efe', value: 'abdurrahim efe' },
            { label: 'Ali Gülhan', value: 'ali gülhan' },
            { label: 'Aslan Aslan', value: 'aslan aslan' },
            { label: 'Ayça Elal', value: 'ayça elal' },
            { label: 'Barış Polat', value: 'barış polat' },
            { label: 'Betül Cirit', value: 'betül cirit' },
            { label: 'Bilal Ceran', value: 'bilal ceran' },
            { label: 'Ecem Altan', value: 'ecem altan' },
            { label: 'Emir Ceran', value: 'emir ceran' },
            { label: 'Emre İliksiz', value: 'emre iliksiz' },
            { label: 'Erdem Aksoy', value: 'erdem aksoy' },
            { label: 'Eymen Dursun', value: 'eymen dursun' },
            { label: 'Gözde Nur Bayar', value: 'gözde nur bayar' },
            { label: 'İbrahim Çelik', value: 'ibrahim çelik' },
            { label: 'İsmail Elal', value: 'ismail elal' },
            { label: 'Kaan Güler', value: 'kaan güler' },
            { label: 'Kübra Çolakbüyük', value: 'kübra çolakbüyük' },
            { label: 'Mesut Şahin', value: 'mesut şahin' },
            { label: 'Neslinur Mutlu', value: 'neslinur mutlu' },
            { label: 'Olgun Kızıltepe', value: 'olgun kızıltepe' },
            { label: 'Onur BAYRAM', value: 'onur bayram' },
            { label: 'Osman DEMİR', value: 'osman demir' },
            { label: 'Şahin Solak', value: 'şahin solak' },
            { label: 'Salih Söğüt', value: 'salih söğüt' },
            { label: 'Selahattin Demirel', value: 'selahattin demirel' },
            { label: 'Sena Demiröz', value: 'sena demiröz' },
            { label: 'Senem Zafer', value: 'senem zafer' },
            { label: 'Serhıldan Hülakü', value: 'serhıldan hülakü' },
            { label: 'Sumru Tarhan', value: 'sumru tarhan' },
            { label: 'Şimal Güdüm', value: 'şimal güdüm' },
            { label: 'Tahsin Erkin Erk', value: 'tahsin erkin erk' },
            { label: 'Temsilci', value: 'temsilci' },
            { label: 'Turan Yiğittekin', value: 'turan yiğittekin' },
            { label: 'Yakupcan Aydemir', value: 'yakupcan aydemir' },
            { label: 'Zehra Aygör', value: 'zehra aygör' },
            { label: 'Zehra Yaşık', value: 'zehra yaşık' },
        ],
    },
    {
        title: 'User Type',
        key: 'ut',
        field_name: 'user_types',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Anonymous',
                value: 'anonymous',
            },
            {
                label: 'Paid',
                value: 'paid',
            },
            {
                label: 'Logged In',
                value: 'loggedin',
            },
        ],
    },
    {
        title: 'Keywords',
        key: 'kw',
        field_name: 'keywords',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'hisse',
        ],
    },
    {
        title: 'Keywords Exclude',
        key: 'kwn',
        field_name: 'not_keywords',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'hisse',
        ],
    },
    {
        title: 'Search',
        key: 'srch',
        field_name: 'search_include',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            '404 hata sayfası',
        ],
    },
]

export const coreApiPageFilterHaberlerObject = new CoreApiFilterObject(FILTER_ID_PAGE_FILTER, FILTER_TYPES.VALUES, coreApiPageFilters)
